export enum CountriesEnumList {
  AUSTRIA = 'austria',
  BELGIUM = 'belgium',
  BULGARIA = 'bulgaria',
  CYPRUS = 'cyprus',
  CROATIA = 'croatia',
  CZECH_REPUBLIC = 'czech_republic',
  DENMARK = 'denmark',
  ESTONIA = 'estonia',
  FINLAND = 'finland',
  FRANCE = 'france',
  GERMANY = 'germany',
  GREECE = 'greece',
  HUNGARY = 'hungary',
  IRELAND = 'ireland',
  ITALY = 'italy',
  LATVIA = 'latvia',
  LITHUANIA = 'lithuania',
  LUXEMBOURG = 'luxembourg',
  MALTA = 'malta',
  NETHERLANDS = 'netherlands',
  POLAND = 'poland',
  PORTUGAL = 'portugal',
  ROMANIA = 'romania',
  SLOVAKIA = 'slovakia',
  SLOVENIA = 'slovenia',
  SPAIN = 'spain',
  SWEDEN = 'sweden',
}
